module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18054/js/img/valuePropModals/FormConditionalLogic/ValueProp1.svg"